import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { api_params } from "./serviceUrls";
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { ToastrService } from 'ngx-toastr';
import * as Bowser from "bowser";

@Injectable({
  providedIn: 'root',
})

export class HttpConfig implements HttpInterceptor {
  token: string;

  private refreshTokenInProgress = false;

  // Refresh Token Subject tracks the current token, or is null if no token is currently
  // available (e.g. refresh pending).
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  browserInfo: Bowser.Parser.ParsedResult;
  ipAddress: any;

  constructor(private router: Router,
    private apiService: ApiService,
    private toastr: ToastrService) {
  }


  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.sendRequest(req, next);
  }


  sendRequest(
    req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    let newReq = this.setParams(req);

    return next.handle(newReq).pipe(
      catchError(error => {

        // If error status is different than 401 we want to skip refresh token
        // So we check that and throw the error if it's the case
        if (error.status !== 401) {
          console.error("Error catched and thrown");
          return throwError(error);
        }


        if (this.refreshTokenInProgress) {
          // If refreshTokenInProgress is true, we will wait until refreshTokenSubject has a non-null value
          // – which means the new token is ready and we can retry the request again

          return this.refreshTokenSubject.pipe(
            filter(result => result !== null),
            take(1),
            switchMap(() => next.handle(this.setParams(newReq)))
          );

        }
        else {
          this.refreshTokenInProgress = true;

          // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
          this.refreshTokenSubject.next(null);

          // Call refresToken(this is an Observable that will be returned)
          this.browserInfo = Bowser.parse(window.navigator.userAgent);
          let obj = {
            jwtToken: localStorage.getItem('access_token'),
            refreshToken: localStorage.getItem('refresh_token'),
            IpAddress: localStorage.getItem('ip'),
            BrowserInfo: this.browserInfo.browser.name + ' ' + this.browserInfo.browser.version,
            OSInfo: this.browserInfo.os.name + ' ' + this.browserInfo.os.version,
            email: 'test@gmail.com',
            password: "testing",
            projectId: 2
          }

          return this.apiService
            .refreshToken(obj)
            .pipe(
              switchMap((token: any) => {
                console.log('my token',token);
                //When the call to refreshToken completes we reset the refreshTokenInProgress to false
                // for the next time the token needs to be refreshed
                localStorage.setItem('access_token', token.data.jwtToken);
                localStorage.setItem('refresh_token', token.data.refreshToken);
                this.refreshTokenInProgress = false;

                this.refreshTokenSubject.next(token);
                return next.handle(this.setParams(newReq));
              }),
              catchError(() => {
                this.refreshTokenInProgress = false;

                // logging out user because refresh_token has expired too along with access_token
                
                this.forceLogout();
                return throwError(error);
              })
            );
        }
      }));
  }


  setParams(req) {
    this.token = localStorage.getItem('access_token');
    var newReq;
    
    //remove domain from already created requests
    if (req.url.includes(environment.BASE_URL)) {
      newReq = req.url.split(environment.BASE_URL);
      req.url = newReq[1];
    }

    // Adding headers to the request
    newReq = req.clone({
      url: environment.BASE_URL + req.url,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.token,
        'X_API_KEY': 'sdf3rfew3ferf$dfvfrrg#dgsrr2342gdasewe&r',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
        'projectId': '2',
      })
    });

    return newReq;
  }


  forceLogout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

}